import { render } from "./IniciarConversaFab.vue?vue&type=template&id=2c7699a6&scoped=true"
import script from "./IniciarConversaFab.vue?vue&type=script&lang=js"
export * from "./IniciarConversaFab.vue?vue&type=script&lang=js"

import "./IniciarConversaFab.vue?vue&type=style&index=0&id=2c7699a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7699a6"]])

export default __exports__